import type { ReactNode } from "react";
import { Frame } from "./illustration-parts.js";
import type { IllustrationKey } from "./onboarding-steps.js";
import { editorScenes } from "./scenes-editor.js";
import { quickviewScenes } from "./scenes-quickview.js";

const scenes: Record<IllustrationKey, () => ReactNode> = {
  ...quickviewScenes,
  ...editorScenes,
} as Record<IllustrationKey, () => ReactNode>;

export function OnboardingIllustration({ name }: { name: IllustrationKey }) {
  return <Frame>{scenes[name]()}</Frame>;
}
